import React, { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import MatchHydrate from './../match-hydrate.js';
import mobileVerify from './../../verification/mobile-verify.js';
import './../../account-settings-mobile-number.js';
import AccountSettingsMobileVerify from './account-settings-mobile-verify.js';
import AccountSettingsMobileEnterCode from './account-settings-mobile-enter-code.js';
import AccountSettingsMobileVerified from './account-settings-mobile-verified.js';
import AccountSettingsMobileError from './account-settings-mobile-error.js';
import shop from './../../shop.js';
import viewBonus from './../../payment/bonus/lib/view-bonus.js';

class AccountSettingsMobile extends Component {

	componentWillMount() {
		this.bonusId = (this.props.location.state && this.props.location.state.hasOwnProperty('bonusId')) ? this.props.location.state.bonusId : '';
		this.referrer = (this.props.location.state && this.props.location.state.hasOwnProperty('referrer')) ? this.props.location.state.referrer: '';
		this.referrerUrl = (this.props.location.state && this.props.location.state.referrerUrl) ? this.props.location.state.referrerUrl : '';
		const okBttn = document.querySelector('.verify-phone').querySelectorAll('.js-verify-phone--step')[2].querySelector('a');

		if (this.bonusId !== '' && this.referrer !== '') {
			if (this.referrer === 'shop') {
				okBttn.setAttribute('href', '/shop');
			} else if (this.referrer === 'register') {
				okBttn.setAttribute('href', '/account/deposit/bonus?referrer=register');
			}
		} else if (this.referrer === 'withdraw') {
			okBttn.setAttribute('href', '/account/withdraw/');
		} else {
			okBttn.setAttribute('href', '/');
		}

		if (this.referrerUrl) {
			okBttn.setAttribute('href', this.referrerUrl);
		}
	}

	componentWillUnmount() {

		const id = this.bonusId;
		const referrer = this.referrer;
		if (this.bonusId !== '' && mobileVerify().currentStep === 'success') {
			mobileVerify().close();
			if (referrer === 'shop') {
				shop.openShopItem(id);
				shop.getOpenedShopItem();
			} else if (referrer === 'register') {
				viewBonus.submitbtnCallbackForFreeMoney(id);
			} else if (referrer === 'deposit') {
				viewBonus.submitbtnCallbackForDeposit(id);
			}
		} else {
			mobileVerify().close();
		}

	}

	render() {
		return (
			<div id="account-verify-mobile">
				<Switch>
					<MatchHydrate authenticate path="/account/mysettings/verify-mobile/verify" component={AccountSettingsMobileVerify} />
					<MatchHydrate authenticate path="/account/mysettings/verify-mobile/enter-code" component={AccountSettingsMobileEnterCode} />
					<MatchHydrate authenticate path="/account/mysettings/verify-mobile/verified" component={AccountSettingsMobileVerified} />
					<MatchHydrate authenticate path="/account/mysettings/verify-mobile/error" component={AccountSettingsMobileError} />
					<Route render={() => <Redirect to="/account/mysettings/verify-mobile/verify" />} />
				</Switch>
			</div>
		);
	}
}

export default AccountSettingsMobile;




// WEBPACK FOOTER //
// ./mobile-core/src/components/account/account-settings-mobile.js